export default {"src":"/_next/static/media/discount.b17ebe2a.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};